/* @flow */

import { API_CALL } from '../constants/actionTypes';
import { CONTACT } from '../constants/apiTypes';
import { sendEnquiry } from '../api/contact';

export function submitEnquiry(data: Object) {
  // eslint-disable-line import/prefer-default-export
  return {
    type: API_CALL,
    api: CONTACT,
    request: sendEnquiry(data)
  };
}
